import customAxios from "../../customAxios";
import { ADMIN_GET_PRIMARY_WALLET } from "../../routes";

const getPrimaryWallet = async (): Promise<any> => {
  try {
    return (await customAxios.get(ADMIN_GET_PRIMARY_WALLET)).data;
  } catch (error: any) {
    console.log({ ADMIN_GET_PRIMARY_WALLET: error });
  }
};

export default getPrimaryWallet;
